import React, { useCallback, useState } from 'react';

import { Button } from 'components/bootstrap';
import type { BsSize } from 'components/bootstrap/types';
import type { StyleProps } from 'components/bootstrap/Button';
import type { EntityShare } from 'actions/permissions/EntityShareActions';
import CollectionModal from 'collections/components/CollectionModal';
import type { Collection } from 'collections/types';
import useCollectionMutation from 'collections/hooks/useCollectionMutation';

type Props = {
  bsSize?: BsSize;
  bsStyle?: StyleProps;
  buttonText?: string;
  editCollection: Collection;
};

const UpdateCollectionButton = ({
  bsSize = 'md',
  bsStyle = 'default',
  buttonText = 'Update collection',
  editCollection,
}: Props) => {
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const toggleUpdateModal = useCallback(() => setShowUpdateModal((cur) => !cur), []);

  const { updateCollection } = useCollectionMutation();

  const onUpdate = (values: Partial<Collection> & EntityShare) =>
    updateCollection({
      title: values.title,
      description: values.description,
      id: editCollection.id,
    });

  return (
    <>
      <Button bsSize={bsSize} bsStyle={bsStyle} onClick={toggleUpdateModal}>
        {buttonText}
      </Button>
      {showUpdateModal && (
        <CollectionModal
          title="Update collection"
          submitButtonText="Update collection"
          submitLoadingText="Updating collection..."
          onSubmit={onUpdate}
          onClose={toggleUpdateModal}
          initialCollection={editCollection}
        />
      )}
    </>
  );
};

export default UpdateCollectionButton;
